import { AttachedContext } from '../AttachedContext';
export class AttachedSkeletonContext extends AttachedContext {
    aspectChildren;
    aspectComponent;
    constructor(at, options = {}) {
        super(at);
        Object.assign(this, options);
    }
    get at() {
        return this.at_raw;
    }
}
